import type { UseFormReturn } from "react-hook-form"
import { FormField } from "../ui-form/form-field"
import { TravelBookingFormValues } from "../lib/schemas/travel-booking"
import { renderField } from "../lib/FormConfigs/Renderer"
import { FieldConfig } from "../lib/FormConfigs/config"
import { useQuery } from "react-query"
import { getCountryList } from "../apis"

interface DestinationStepProps {
  form: UseFormReturn<TravelBookingFormValues>
  config?: FieldConfig[]
}

export function DestinationStep({ form, config }: DestinationStepProps) {
  const {data} = useQuery({
    queryKey: ['country-list'],
    queryFn: () => getCountryList(),
    enabled: !!form.getValues('destination.purposeOfTravel'),
    staleTime: 1000 * 60 * 60, // 1 hour
  })

  const countryToFilter = ['pakistan', 'bhutan', 'nepal']

  const countryList = data?.map((item) => ({
    value: item?.name?.common?.toLowerCase() || item?.name?.official?.toLowerCase(),
    label: item?.name?.common || item?.name?.official,
  })).filter((item) => !countryToFilter.includes(item?.value?.toLowerCase()))
  return (
    <div className="max-w-sm">
      <div className="grid grid-cols-[auto_1fr] gap-x-[18.5px]">
        {config?.map((field, index) => {
          const isCompleted = form.watch(field.name as keyof TravelBookingFormValues)
          const isLast = index === config.length - 1

          return (
            <>
              {/* Step indicator column */}
              <div key={`indicator-${field.name}`} className="flex flex-col items-center justify-start">
                {/* Circle indicator */}
                <div
                  className={`
                    w-[9px] h-[9px] rounded-full border mt-1.5 flex-shrink-0
                    transition-colors duration-300
                    ${isCompleted ? "bg-blue-700 border-blue-700" : "bg-white-A700 border-blue-700"}
                  `}
                />
                
                {/* Dotted line (except for last item) */}
                {!isLast && (
                  <div className={`w-0.5 flex-1 border-l-2 border-dotted min-h-[1.5rem] ${isCompleted ? 'border-blue-700 ' : 'border-gray-300 '}`} />
                )}
              </div>

              {/* Form field column */}
              <div key={`field-${field.name}`} className="pb-6">
                <FormField
                  form={form}
                  name={field.name as keyof TravelBookingFormValues}
                  label={field.label}
                  render={({ field: formField }) => {
                    if(field.name === 'destination.destination' && field.type === 'select') {
                      const selectField = { ...field, options: countryList || [] }
                      return renderField(selectField, formField)
                    }
                    return (
                      <div>
                        {renderField(field, formField)}
                      </div>
                    )
                  }}
                />
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}